import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star } from 'lucide-react';
const topTestimonials = [{
  quote: 'Llevaba 4 años con la mancha en el dormitorio. Probé de todo. Con el Módulo 1 entendí de dónde venía el agua por primera vez. A los 21 días de la inyección, la pared estaba seca.',
  name: 'Marcelo R.',
  desc: 'Quilmes · Propietario'
}, {
  quote: 'El sistema me hizo darme cuenta que estaba regalando plata a las empresas. Hice la obra yo mismo con $52.000 en materiales. La empresa me había pedido $780.000.',
  name: 'Diego F.',
  desc: 'Rosario · Propietario'
}, {
  quote: 'Lo que más me sorprendió fue el Árbol de Decisión del Módulo 1. Iba a inyectar donde no hacía falta. Me salvó de gastar $60.000 en materiales que no necesitaba.',
  name: 'Claudia M.',
  desc: 'Córdoba · Propietaria'
}];
export function TopTestimonialsSection() {
  return <section className="py-8 px-4 bg-slate-950 border-b border-slate-800/50" data-id="element-288">
      <div className="max-w-6xl mx-auto" data-id="element-289">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-290">
          {topTestimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} direction="up" data-id="element-291">
              <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6 h-full flex flex-col" data-id="element-292">
                <div className="flex gap-1 mb-4" data-id="element-293">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-orange-500 text-orange-500" data-id="element-294" />)}
                </div>
                <p className="text-slate-300 italic mb-6 flex-grow" data-id="element-295">
                  "{t.quote}"
                </p>
                <div data-id="element-296">
                  <p className="text-white font-bold text-sm" data-id="element-297">{t.name}</p>
                  <p className="text-slate-500 text-xs" data-id="element-298">{t.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}